@if (wrapper && wrapper.isReady) {
  <div [formGroup]="wrapper.form" [class]="getFormGroupClass()">
    <div class="form-check form-switch">
      <input #input class="form-check-input" type="checkbox"
             [id]="name"
             [formControlName]="name"
             (change)="onChange($event)"
             (click)="onClick($event)"
             [class.is-invalid]="isInvalid()"
             [class.disabled]="isViewOnly()">
      <acc-form-label [name]="name" [wrapper]="wrapper" [size]="getSize()"/>
    </div>
  </div>
}
